export default {
    'name': 'gpt',
    'label': 'Ai Summary',
    'getComponent': () => import('./Gpt.vue'),
    'tabIndex': 10,
    'left': false,
    'right': true,
    'singleView': true,
    'compareView': true,
    'exclusiveRoutePath': '/gpt',
    'selfHandelPadding': true,
    'aclCheckKey': 'aiSummary'
};
